import { Component, OnInit, Input, Output, OnChanges, AfterViewInit, OnDestroy, EventEmitter, SimpleChanges} from '@angular/core';
import { Subscription } from 'rxjs';
import { NbGetters, NbTreeGridDataSource, NbTreeGridDataSourceBuilder, NbTreeGridService, NbTreeGridPresentationNode } from '@nebular/theme';
import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl, NestedTreeControl} from '@angular/cdk/tree';
import { TreeTableService } from './tree-table.service';

interface TreeNode {
  data: any;
  expanded?: boolean;
  level: number;
}


interface SelectionChange<T> {
  source: SelectionModel<T>;
  added: T[];
  removed: T[];
}


@Component({
  selector: 'nbx-tree-table',
  templateUrl: './tree-table.component.html',
  styleUrls: ['./tree-table.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class TreeTableComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() headercolor = '#000'; 
  @Input() addCheckboxes = 'false';
  @Input() customColumn = ' ';
  @Input() columns;
  @Input() tog = 'false';
  @Input() status = "primary";
  @Input() toggleall: string = 'false';
  @Input() expandall: string = 'false';
  @Input() collapseall: string = 'false';
  @Output() selected : EventEmitter<any> = new EventEmitter()
  @Output() allselected: EventEmitter<any> = new EventEmitter()

  // @ViewChildren('expandtoggle') expandToggle;

  defaultColumns;
  allColumns;
  data;
  source: NbTreeGridDataSource<any>;
  getters: NbGetters<any, any>
  tree;
  treeControl;
  clickToggle = false;
  checkboxes = false;
  expandAll = true;
  allExpanded = false;
  allCollapsed = false;


   /** The selection for checklist */
  checklistSelection: SelectionModel<any>;
  checkSubsbscription: Subscription;

  constructor(
    private dataSourceBuilder: NbTreeGridDataSourceBuilder<any>) {
    this.getters  = {
      dataGetter: (node: any) => node,
      childrenGetter: (node: any) => node.children || undefined,
      expandedGetter: (node: any) => node.expanded === 'true',
    };
    this.data = this.datajson;
    // console.log("Default type:", typeof this.data);
    this.tree = function (data, root) {
        var t = {};
        data.forEach(o => {
            Object.assign(t[o.id] = t[o.id] || {}, o);
            t[o.__parent] = t[o.__parent] || {};
            t[o.__parent].children = t[o.__parent].children || [];
            t[o.__parent].children.push(t[o.id]);

            if(o.__parent != "parent"){
              t[o.id].parentIdx = t[root].children.indexOf(t[o.__parent])
              t[o.id].idx = t[o.__parent].children.indexOf(t[o.id])
            } 
            else {
              t[o.id].parentIdx = null
              t[o.id].idx = t[root].children.indexOf(t[o.id])
            } 
        });
        return t[root].children;
    }(this.data, "parent");

    // this.defaultColumns = (Object.keys(this.data[0]));
    // this.allColumns = [ this.customColumn, ...this.defaultColumns ];
    this.source = this.dataSourceBuilder.create(this.tree, this.getters);
    // console.log(this.treeControl)
  }

  ngOnInit() {
    // console.log(this.headers);
    this.defaultColumns = this.columns ? JSON.parse(this.columns) : ["TV", "Direct Mail", "Display", "Unbranded Search", "Branded Search", "Radio", "Video", "Print","Social", "Audio"];
    this.allColumns = [ this.customColumn, ...this.defaultColumns ];

    this.treeControl = this.source['data']['value'];

    this.resetSelection()

    this.checkboxes = this.addCheckboxes === 'true' ? true : false;
    this.clickToggle = this.tog === 'true' ? true : false;
    this.expandAll = this.expandall  === 'true' ? true : false;
  }

  ngAfterViewInit() {
    this.toggleRows()
  }

  //TreeNode<any>[]
  @Input() datajson: any = [
    {
      "id": "1",
      "name": "USA CPMTGA",
      "Total": "$2,331.82",
      "TV": "$1,876.09",
      "Direct Mail": "$1,845.87",
      "Display": "$3,116.83",
      "Unbranded Search": "$3,872.12",
      "Branded Search": "$3,490.08",
      "Radio": "$3,029.31",
      "Video": "$32,788.00",
      "Print": "$471.16",
      "Social": "$67,301.15",
      "Audio": "$119,706.79",
      "expanded": "true",
      "checkstatus": "false",
      "__color": "#000",
      "__parent": "parent"
    },
    {
      "id": "2",
      "name": "EAST CPMTGA",
      "Total": "$3,424.81",
      "TV": "$2,248.11",
      "Direct Mail": "$3,657.02",
      "Display": "$5,030.12",
      "Unbranded Search": "$16,615.51",
      "Branded Search": "$4,002.07",
      "Radio": "$193,255.16",
      "Video": "$77,049.95",
      "Print": "$831,943.85",
      "Social": "$193,976.34",
      "Audio": "$1,186,548.49",
      "checkstatus": "false",
      "__color": "#0084D6",
      "__parent": "parent"
    },
    {
      "id": "3",
      "name": "WEST CPMTGA",
      "Total": "$1,393.94",
      "TV": "$1,215.41",
      "Direct Mail": "$1,084.78",
      "Display": "$1,687.00",
      "Unbranded Search": "$1,900.32",
      "Branded Search": "$2,005.53",
      "Radio": "$1,934.29",
      "Video": "$15,805.20",
      "Print": "$402.72",
      "Social": "$31,928.22",
      "Audio": "$49,982.01",
      "checkstatus": "false",
      "__color": "orange",
      "__parent": "parent"
    },
    {
      "id": "4",
      "name": "USA MTGA",
      "Total": "$20,927.82",
      "TV": "$9,861.75",
      "Direct Mail": "$4,713.24",
      "Display": "$2,118.90",
      "Unbranded Search": "$1,195.41",
      "Branded Search": "$1,168.45",
      "Radio": "$823.53",
      "Video": "$61.54",
      "Print": "$966.30",
      "Social": "$17.52",
      "Audio": "$1.17",
      "checkstatus": "false",
      "__color": "#000",
      "expanded": false,
      "__parent": 'parent'
    },
    {
      "id": "5",
      "name": "EAST MTGA",
      "Total": "$9,664.76",
      "TV": "$6,309.20",
      "Direct Mail": "$1,394.58",
      "Display": "$906.24",
      "Unbranded Search": "$160.18",
      "Branded Search": "$868.81",
      "Radio": "$4.71",
      "Video": "$17.06",
      "Print": "$0.08",
      "Social": "$3.82",
      "Audio": "$0.07",
      "checkstatus": "false",
      "__color": "#0084d6",
      "__parent": "4"
    },
    {
      "id": "6",
      "name": "WEST MTGA",
      "Total": "$11,263.06",
      "TV": "$3,552.56",
      "Direct Mail": "$3,318.66",
      "Display": "$1,212.66",
      "Unbranded Search": "$1,035.23",
      "Branded Search": "$299.64",
      "Radio": "$818.82",
      "Video": "$44.47",
      "Print": "$966.22",
      "Social": "$13.69",
      "Audio": "$1.10",
      "checkstatus": "false",
      "__color": "orange",
      "__parent": "4"
    },
    {
      "id": "7",
      "name": "USA Spend(000)",
      "Total": "$48,800.00",
      "TV": "$18,501.56",
      "Direct Mail": "$8,700.00",
      "Display": "$6,604.27",
      "Unbranded Search": "$4,628.78",
      "Branded Search": "$4,077.97",
      "Radio": "$2,494.73",
      "Video": "$2,017.75",
      "Print": "$455.28",
      "Social": "$1,179.04",
      "Audio": "$140.61",
      "checkstatus": "false",
      "__color": "#000",
      "__parent": 'parent'
    },
    {
      "id": "8",
      "name": "EAST Spend(000)",
      "Total": "$33,100.00",
      "TV": "$14,183.76",
      "Direct Mail": "$5,100.00",
      "Display": "$4,558.51",
      "Unbranded Search": "$2,661.52",
      "Branded Search": "$3,477.04",
      "Radio": "$910.90",
      "Video": "$1,314.82",
      "Print": "$66.16",
      "Social": "$741.79",
      "Audio": "$85.50",
      "checkstatus": "false",
      "__color": "#0084d6",
      "__parent": "7"
    },
    {
      "id": "9",
      "name": "WEST Spend(000)",
      "Total": "$15,700.00",
      "TV": "$4,317.81",
      "Direct Mail": "$3,600.00",
      "Display": "$2,045.76",
      "Unbranded Search": "$1,967.26",
      "Branded Search": "$600.93",
      "Radio": "$1,583.84",
      "Video": "$702.93",
      "Print": "$389.12",
      "Social": "$437.25",
      "Audio": "$55.11",
      "checkstatus": "false",
      "__color": "orange",
      "__parent": "7"
    }
  ]

  getPadding(rowLevel) {
    const nestingLevel =  rowLevel * 0.5;

    let padding: string = '';
    const initialPadding = '1.25rem'
    // console.log(rowLevel)

    padding = `calc(${initialPadding} + ${nestingLevel}rem)`

    return padding
  }

  toggleRows() {
    var tree = []
    if (this.treeControl) {
      this.treeControl.forEach(parent => {
        if(this.expandAll) {
          parent.expanded = true
        }
        else { // collapse all 
          parent.expanded = false
        }
      })
      const ExpandGetters  = {
        dataGetter: (node: any) => node.data,
        childrenGetter: (node: any) => node.children || undefined,
        expandedGetter: (node: any) => node.expanded,
      };
      this.source = this.dataSourceBuilder.create(this.treeControl, ExpandGetters);
      this.treeControl = this.source['data']['value'];
      this.resetSelection()
      // console.log(this.treeControl)
    }
  }

  // showelement() {
  //   this.expandToggle.toArray().forEach(val => {
  //     const attr = val
  //     console.log(attr)
  //     if (attr === 'expand') {
  //       console.log(val)
  //       // val.nativeElement.trigger('click')
  //     };
  //   })
  // }


  getWeight(row) {
    if (row.__parent === 'parent')
    {
      return 'bold';
    }
    return 'normal';
  }

  getCheckStatus(row): boolean  { 
    if (row.data.__parent === "parent") {
      return this.checklistSelection.isSelected(this.treeControl[row.data.parentIdx])
    }
    else {
      return this.checklistSelection.isSelected(this.treeControl[row.data.parentIdx].children[row.data.idx])
    }
  }

  childrenAllSelected(row): boolean  {
    // console.log(this.treeControl)
    // console.log(row)
    const node = this.treeControl[row.data.idx]
    const children =  this.getters.childrenGetter(node)

    const childAllSelected = children.length > 0 && children.every(child => {
      this.checklistSelection.isSelected(child)
      return this.checklistSelection.isSelected(child);
    });

    return childAllSelected

  }

  /** Whether part of the chilren are selected */
  childrenPartiallySelected(node): boolean {

    const children = this.getters.childrenGetter(node);
    const result = children.some(child => this.checklistSelection.isSelected(child));
    return result && !this.childrenAllSelected(node);
  }

  
  /** Toggle the parent item selection. Select/deselect all the descendants node */
  parentSelectionToggle(node): void {
    
    this.checklistSelection.toggle(node);
    const children = this.getters.childrenGetter(node);
    
    // console.log(this.checklistSelection.isSelected(node))
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...children)
      : this.checklistSelection.deselect(...children);
      

    // Force update for the parent
    children.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);

    // console.log(this.checklistSelection)
  }

  /** Toggle a child item selection. Check all the parents to see if they changed */
  childSelectionToggle(node): void {
    // console.log(node);
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a child node is selected/unselected */
  checkAllParentsSelection(node): void {
    let parent = this.getParentNode(node)
    // console.log(this.checklistSelection.isSelected(node))
    // console.log("Parent Node:", parent)
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node): void {
    const { dataGetter, childrenGetter, expandedGetter } = this.getters; 
    const nodeSelected = this.checklistSelection.isSelected(node);
    const children = this.getters.childrenGetter(node);
    // console.log("childrenLen: ", children.length);
    // console.log("children: ", children);
    const descAllSelected =
      children.length > 0 &&
      children.every(child => {
        // console.log(this.checklistSelection.selected)
        // console.log("child:", child)
        // console.log("selected: ", this.checklistSelection.selected[0] === child)
        return this.checklistSelection.isSelected(dataGetter(child));
      });
      // console.log("descAllSelected: ", descAllSelected)
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
    // console.log("parentselected: ", this.checklistSelection.isSelected(node));
  }

  /* Get the parent node of a node */
  getParentNode(node) {
    const { dataGetter, childrenGetter, expandedGetter } = this.getters; 
    // console.log(this.source)
    const currentLevel = node.level;

    if (currentLevel < 1) {
      return null;
    }

    if (node.data.__parent != "parent") {
      return dataGetter(this.treeControl[parseInt(node.data.__parent) - 1])
    }
    // for(i = 0; )
    // // for 
    return null;
  }

  get isAllSelected(): boolean {
    return this.checklistSelection.selected.length === this.datajson.length;
  }

  toggleSelectAll(): void {
    if (this.isAllSelected) {
      this.deselectAll();
    } else {
      this.selectAll();
    }
  }

  checkAllChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.selectAll();
    }
    else {
      this.deselectAll();
    }
  }

  selectAll(): void {
    this.treeControl.map((node) => {

      if(node.hasChildren()) {
        node.children.forEach(child => this.checklistSelection.select(child))
      }
      this.checklistSelection.select(node)
    })

    // treeNodes = this.source['renderData']['value'];
  }

  deselectAll(): void {
    this.checklistSelection.clear();
  }


  ngOnChanges(changes: SimpleChanges) {
    for(const propName in changes)
    {
      if (changes.hasOwnProperty(propName)) {
        switch(propName) {
          case 'columns': {
            this.defaultColumns = this.columns ? JSON.parse(this.columns) : ["TV", "Direct Mail", "Display", "Unbranded Search", "Branded Search", "Radio", "Video", "Print","Social", "Audio"];
            this.allColumns = [ this.customColumn, ...this.defaultColumns ];

            this.resetSelection()
          }
          case 'datajson': {
            // console.log(JSON.parse(this.datajson));
            this.data = JSON.parse(this.datajson);
            // console.log("Changed type:", this.data);
            var tree = function (data, root) {
                var t = {};
                data.forEach(o => {
                    Object.assign(t[o.id] = t[o.id] || {}, o);
                      t[o.__parent] =  t[o.__parent] || {};
                      t[o.__parent].children = t[o.__parent].children || [];
                      t[o.__parent].children.push(t[o.id]);

                      if(o.__parent != "parent"){
                        t[o.id].parentIdx = t[root].children.indexOf(t[o.__parent])
                        t[o.id].idx = t[o.__parent].children.indexOf(t[o.id])
                      } 
                      else {
                        t[o.id].parentIdx = null
                        t[o.id].idx = t[root].children.indexOf(t[o.id])
                      } 
                });
                // console.log("t changed:", t);
                return t[root].children;
            }(this.data, "parent");
        
            this.source = this.dataSourceBuilder.create(tree, this.getters);
            this.treeControl = this.source['data']['value'];
            this.resetSelection()
          }
          case 'addCheckboxes': {
            this.checkboxes = this.addCheckboxes === 'true' ? true : false
            this.resetSelection()
          }
          case 'clickToggle': {
            this.clickToggle = this.tog === 'true' ? true : false
          }
          case 'toggleall': {

            if (this.toggleall === 'true') {
              this.toggleSelectAll()
            }
          }
          case 'expandall': {
            if (this.expandall === 'true') {
              this.expandAll = true
              this.toggleRows()
            }
            else {
              this.expandAll = false
            }
          }
          case 'collapseall': {
            if (this.collapseall === 'true') {
              this.expandAll = false
              this.toggleRows()
            }
          }
        }
      }
    }
  }

  resetSelection() {
    // destroy old subscription
    if(this.checklistSelection) {
      this.deselectAll()
    }

    if (this.checkSubsbscription) {
      this.checkSubsbscription.unsubscribe();
    }
    this.checklistSelection = new SelectionModel<any>(true)
    
    this.checkSubsbscription = this.checklistSelection.changed.subscribe((change: SelectionChange<any>) => {
      // console.log(change)
      this.selected.emit(change);
      this.allselected.emit(this.isAllSelected);
    })
  }

  ngOnDestroy() {
    if(this.checklistSelection) {
      this.deselectAll()
    }

    if (this.checkSubsbscription) {
      this.checkSubsbscription.unsubscribe();
    }
  }
}